var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50","cy":"50","r":"50","fill":"black","key":0}),React.createElement("rect",{"x":"72.0781","y":"21.7549","width":"9","height":"71.2366","rx":"4.5","transform":"rotate(45 72.0781 21.7549)","fill":"white","key":1}),React.createElement("rect",{"x":"78.4424","y":"72.1267","width":"9","height":"71.2366","rx":"4.5","transform":"rotate(135 78.4424 72.1267)","fill":"white","key":2})]);
}

CloseIcon.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
